export default __webpack_public_path__ + "static/media/icon-email-success.cd657a98.png";